// src/components/composite-fillingsContent.js
import React from 'react';
import './CompositeFillingContent.css'; // Assuming you have a CSS file for styling


const CompositeFillingContent = () => {
  return (
    <div className="composite-fillings">
      <div className="composite-fillings-overview-container">
          <div className="composite-fillings-overview-info">
            <h2 className="composite-fillings-overview-header">Composite Fillings</h2>
            <div className="composite-fillings-custom-line"></div>
            <p className="composite-fillings-text">
            A composite (tooth colored) filling is used to repair a tooth that is affected by decay, cracks, fractures, etc.  The decayed or affected portion of the tooth will be removed and then filled with a composite filling.
            </p>
            <p className="composite-fillings-text">
              There are many types of filling materials available, each with their own advantages and disadvantages.  You and your dentist can discuss the best options for restoring your teeth.  Composite fillings, along with silver amalgam fillings, are the most widely used today.  Because composite fillings are tooth colored, they can be closely matched to the color of existing teeth, and are more aesthetically suited for use in front teeth or the more visible areas of the teeth.
            </p>
            <p className="composite-fillings-text">
              As with most dental restorations, composite fillings are not permanent and may someday have to be replaced.  They are very durable, and will last many years, giving you a long lasting, beautiful smile.
            </p>
          </div>

          <div className="composite-fillings-image-container">
            <img 
              src="/images/composite-fillings.jpeg" 
              alt="Composite Fillings" 
              className="composite-fillings-1"
            />
          </div>
      </div>

      <div className="composite-fillings-description-container">
        <div className="composite-fillings-reasons-container">
          <h3 className="composite-fillings-reasons-header">Reasons for Composite Fillings</h3>
          <ul className="composite-fillings-reasons-list">
            <li>Chipped teeth</li>
            <li>Closing space between two teeth</li>
            <li>Cracked or broken teeth</li>
            <li>Decayed teeth</li>
            <li>Worn teeth</li>
          </ul>
        </div>

        <div className="composite-fillings-steps-container">
          <h3 className="composite-fillings-steps-header">How are composite fillings placed? </h3>
          <p className="composite-fillings-steps-text">Composite fillings are usually placed in one appointment.  While the tooth is numb, your dentist will remove decay as necessary.  The space will then be thoroughly cleaned and carefully prepared before the new filling is placed.  If the decay was near the nerve of the tooth, a special medication will be applied for added protection.  The composite filling will then be precisely placed, shaped, and polished, restoring your tooth to its original shape and function.It is normal to experience sensitivity to hot and cold when composite fillings are first placed, however this will subside shortly after your tooth acclimates to the new filling.</p>
          <p className="composite-fillings-steps-text">You will be given care instructions at the conclusion of your treatment.  Good oral hygiene practices, eating habits, and regular dental visits will aid in the life of your new fillings.</p>
        </div>

      </div>
    </div>
  );
};

export default CompositeFillingContent;